export default __webpack_public_path__ + "static/media/266.f3912abb.png";